import { render } from "./Chapter1.vue?vue&type=template&id=52aab2ff"
import script from "./Chapter1.vue?vue&type=script&lang=js"
export * from "./Chapter1.vue?vue&type=script&lang=js"

import "./Chapter1.vue?vue&type=style&index=0&id=52aab2ff&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__